import React from "react";
import { MainSurveyStore } from "modules/MainSurveyEditor/hooks/useMainSurvey";
import { useRelatedSupportingInfo } from "modules/SupportingInfo/hooks/useRelatedSupportingInfo";
import { RelatedSupportingInfosView } from "./RelatedSupportingInfosView";

export const RelatedSupportingInfos = (props: SupportingInfoProps) => {
  const { mainSurveyStore, isSubBlock } = props;
  const hook = useRelatedSupportingInfo(mainSurveyStore, isSubBlock);

  return (
    <RelatedSupportingInfosView
      controller={{
        relatedInfos: hook.relatedInfos,
        infoOptions: hook.infoOptions,
        isLoadingInfoOptions: hook.isLoadingInfoOptions,
        addSupportingInfo: hook.addSupportingInfo,
        handleSelectSupportingInfo: hook.handleSelectSupportingInfo,
        handleContentUpdate: hook.handleContentUpdate,
        handleTabNameUpdate: hook.handleTabNameUpdate,
        handleDeleteInfo: hook.handleDeleteInfo,
        setIsSaving: mainSurveyStore.setIsSaving,
      }}
    />
  );
};

interface SupportingInfoProps {
  mainSurveyStore: MainSurveyStore;
  isSubBlock: boolean;
}
